export const NAV_LINKS: { id: string; label: string }[] = [
  { id: 'features', label: 'Features' },
  { id: 'benefits', label: 'Benefits' },
  { id: 'contact', label: 'Contact' },
];

export const FEATURES: { icon: string; title: string; description: string }[] = [
  {
    icon: 'Clock',
    title: 'Attendance & Time Tracking',
    description:
      'Geolocation-aware check-in/out with office detection and multi-interval tracking for accurate, effortless timesheets.',
  },
  {
    icon: 'CalendarCheck',
    title: 'Leave Management',
    description:
      'Apply, approve and track leave with live balances, configurable leave types and a streamlined approver inbox.',
  },
  {
    icon: 'Home',
    title: 'KRA & Goals',
    description:
      'Set, track and review Key Result Areas (KRAs) and goals to ensure alignment and accountability across teams.',
  },
  {
    icon: 'UserPlus',
    title: 'Guided Onboarding',
    description:
      'Welcome new hires with a step-by-step wizard covering personal, bank, document and policy acknowledgements.',
  },
  {
    icon: 'Users',
    title: 'Employee Management',
    description:
      'A single source of truth for your people — profiles, departments, designations, locations and reporting lines.',
  },
  {
    icon: 'Ticket',
    title: 'Ticket Management',
    description:
      'Built-in helpdesk so employees can raise, track and resolve HR and IT requests without leaving the platform.',
  },
  {
    icon: 'Boxes',
    title: 'Asset Management',
    description:
      'Assign and monitor company assets across your workforce with clear ownership and full accountability.',
  },
  {
    icon: 'ShieldCheck',
    title: 'Roles & Permissions',
    description:
      'Granular, role-based access control with a visual permissions matrix keeps sensitive data in the right hands.',
  },
  {
    icon: 'KeyRound',
    title: 'Microsoft 365 SSO',
    description:
      'Secure single sign-on with Microsoft 365 plus multi-organisation support for seamless, enterprise-ready access.',
  },
];

export const BENEFITS: { icon: string; title: string; description: string }[] = [
  {
    icon: 'Zap',
    title: 'Automate the busywork',
    description:
      'Replace spreadsheets and manual approvals with smart workflows, so HR spends time on people — not paperwork.',
  },
  {
    icon: 'LayoutDashboard',
    title: 'One connected platform',
    description:
      'Attendance, leave, assets, tickets and documents live together, giving everyone a single, reliable view.',
  },
  {
    icon: 'Sparkles',
    title: 'Employee self-service',
    description:
      'Empower your team to manage their own attendance, leave and requests from any device, anytime.',
  },
  {
    icon: 'Lock',
    title: 'Secure by design',
    description:
      'Role-based access, M365 authentication and audit-friendly records keep your organisation compliant.',
  },
  {
    icon: 'Globe',
    title: 'Works anywhere',
    description:
      'A fully responsive experience with light and dark modes that feels right on desktop, tablet and mobile.',
  },
  {
    icon: 'TrendingUp',
    title: 'Scales with you',
    description:
      'Multi-organisation support and configurable master data grow with your teams as your company evolves.',
  },
];

export const STATS: { value: string; label: string }[] = [
  { value: '9+', label: 'Integrated HR modules' },
  { value: '24/7', label: 'Self-service access' },
  { value: 'M365', label: 'Single sign-on ready' },
  { value: '100%', label: 'Role-based security' },
];
